import { assignWith, mapValues } from 'lodash';

/**
 * Sum numbers from source to object. Note that it mutates object
 * @param {Record<string, number>} object - destination object
 * @param {Record<string, number>} source - source object
 * @returns object
 */
export const sumNumberRecords = <R extends Record<string, number>>(
  object: R,
  ...source: R[]
): R => assignWith(object, ...source, (l = 0, r = 0) => l + r);

/**
 * Flip signs of numbers in object
 * @param {Record<string, number>} object - destination object
 * @returns new object
 */
export const negativeNumberRecord = <R extends Record<string, number>>(
  object: R,
): R => mapValues(object, (value) => -value) as R;
